import React from 'react';
import './CommonStyles.css';

const BusinessLocations = () => {
    return (
        <div className="module-container">
            <div className="module-header">
                <h2>Business Locations</h2>
            </div>
            <div className="placeholder-content">
                <h3>📍 Business Locations</h3>
                <p>Manage multiple storefronts, warehouses, and branches.</p>
            </div>
        </div>
    );
};

export default BusinessLocations;
